import * as Dialog from '@radix-ui/react-dialog';
import { Button } from 'components/ui/button';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { discardData } from 'store/slices/podcastResponse';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { discardFormData } from 'store/slices/podcastGen';

const DiscardPodcast = () => {
  const [open, setOpen] = useState<boolean>(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleDiscard = () => {
    dispatch(discardData()); // remove the podcast dialogues
    dispatch(discardFormData()); // remove the form data stored
    
    // Also remove any saved podcast state from localStorage
    localStorage.removeItem('pending_podcast');
    
    toast.success('Podcast discarded!');
    navigate('/ai-podcast-generator/get-started');
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <Button
          variant="customSecondary"
          className="font-normal text-sm px-4 w-full"
          size="sm"
        >
          Discard
        </Button>
      </Dialog.Trigger>
      <Dialog.Overlay className="fixed inset-0 bg-black/50 z-10" />
      <Dialog.Content className="fixed inset-0 flex items-center justify-center p-4 z-50">
        <div className="bg-background-main text-text-primary rounded-lg shadow-lg p-6 w-full max-w-[90%] sm:max-w-[480px] flex flex-col gap-1">
          <Dialog.Title className="text-2xl text-left font-bold text-primary ">
            Discard Podcast
          </Dialog.Title>
          <Dialog.Description className=" max-w-[480px] mt-2 text-left text-[15px] font-normal">
            Once the podcast is discarded you wont be able to get it back. Are
            you sure you want to continue?
          </Dialog.Description>
          <div className="flex flex-row justify-end mt-6 w-full gap-2">
            <Button
              variant="customSecondary"
              size="sm"
              onClick={() => setOpen(false)}
              className="text-[14px] bg-secondary"
            >
              Cancel
            </Button>

            <Button
              variant="customSecondary"
              size="sm"
              className="text-[14px] bg-secondary"
              onClick={handleDiscard}
            >
              Discard
            </Button>
          </div>
        </div>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default DiscardPodcast;
